import * as React from 'react';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import didserver from 'src/api/systemManage/companyInfo';
import { message } from 'antd';

class ModulesAction extends ActionBasic<ModulesState> {
    tabsOnChange = (key) => {
        this.modulesState.activeKey = key;
        this.setModulesState();
    }
    getDidList = async (params) => {
        const res: any = await didserver.getdidlist(this, params);
        if (res.er) {
            return;
        } else {
            this.modulesState.pageMeta = res.res.pageMeta;
            this.modulesState.list = res.res.items;
            this.setModulesState();
        }
    }
    setDefault = async id => {
        const res = await didserver.setdidDefault(this, { id }) as any;
        if (res.er) {
            return;
        } else {
            message.success('操作成功');
            this.getDefaultList();
        }
    }
    reSubmit = async id => {
        const res = await didserver.ResubmitDid(this, { id }) as any;
        if (res.er) {
            return;
        } else {
            message.success('操作成功');
            this.getDefaultList();
        }
    }
    /**
     * 创建新did
     * @param 
     */
    createDid = async (values) => {
        const res: any = await didserver.createdid(this, values);
        if (res.er) {

        } else {
            message.success('操作成功');
            this.getDefaultList();
            this.modulesState.showModal=false;
            this.setModulesState();
        }
    }
    getDefaultList = () => {
        const data = {
            ...this.modulesState.params,
            ...this.modulesState.pageMeta,
            pageNum: 1
        };
        this.getDidList(data);
    }

}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/platform/DiDManager/Modules.Action.tsx